function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 10.524,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.3675788
    },
    d: "M19.377.232h-3.303l.011 7.767L13.21.229h-2.852L7.904 6.718C7.643 5.067 5.936 4.497 4.593 4.07c-.887-.285-1.829-.704-1.82-1.167.008-.38.504-.732 1.49-.68.662.036 1.247.09 2.41.65L7.814.882C6.755.341 5.29.001 4.087 0H4.08C2.68 0 1.511.454.788 1.202a2.774 2.774 0 0 0-.787 1.92c-.019 1.01.352 1.726 1.13 2.298.657.482 1.497.794 2.238 1.024.913.283 1.66.529 1.65 1.053a.776.776 0 0 1-.217.514c-.227.235-.577.323-1.06.333-.933.02-1.624-.127-2.725-.778L0 9.584c1.1.626 2.268.94 3.595.94l.298-.002c1.155-.021 2.093-.298 2.837-.897.043-.034.081-.069.12-.104l-.124.644 2.786-.009.5-1.28c.526.18 1.123.279 1.758.279.618 0 1.2-.094 1.715-.263l.349 1.264 4.999.005.012-2.918h1.064C22.48 7.243 24 5.935 24 3.74 24 1.296 22.522.232 19.377.232ZM11.77 6.87a2.988 2.988 0 0 1-1.054-.185l1.042-3.291h.02l1.026 3.3c-.309.11-.66.176-1.034.176Zm7.8-1.891h-.726V2.327h.726c.967 0 1.739.322 1.739 1.31 0 1.021-.772 1.343-1.739 1.343"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSap);
export default __webpack_public_path__ + "static/media/sap.e563582fbdb9e1683e397cdb7f3aacb9.svg";
export { ForwardRef as ReactComponent };